import {
  BulkPaymentDetailPageDocument,
  BulkPaymentTransferStatsDocument,
  BulkPaymentTransfersDataCollectionDocument,
  MarkAsPaidPaymentExecutionDocument,
  PaymentsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useMarkAsPaidPaymentExecution = () => {
  const [markAsPaid, { loading }] = useMutation(MarkAsPaidPaymentExecutionDocument, {
    extractorFn: (data) => data.bankingMutations.markAsPaidBankingPaymentExecution,
    refetchQueries: [
      PaymentsDataCollectionDocument,
      BulkPaymentDetailPageDocument,
      BulkPaymentTransferStatsDocument,
      BulkPaymentTransfersDataCollectionDocument,
    ],
    awaitRefetchQueries: true,
  })

  const markAsPaidPaymentExecution = async (paymenExecutiontId: string) => {
    const result = await markAsPaid({
      variables: {
        id: paymenExecutiontId,
      },
    })
    const handled = handleResult(result, () => {})
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('banking.payment_executions.marked_as_paid'),
      })
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_error'),
      })
    }
    return handled
  }

  return {
    markAsPaidPaymentExecution,
    loading,
  }
}
